import script from "./ClubPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubPage.vue?vue&type=script&setup=true&lang=js"

import "./ClubPage.vue?vue&type=style&index=0&id=aac52bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aac52bca"]])

export default __exports__